const skipLinkStateStore = defineStore('skipLinkState', () => {
  const skipLinkTargetId = ref<string>(null)
  const skipLinkMessage = ref<LangString>({})
  return {
    skipLinkTargetId,
    skipLinkMessage,
  }
})

export const useSkipLink = () => {
  const route = useRoute()
  const store = skipLinkStateStore()

  const reset = () => {
    store.skipLinkTargetId = '#main'
    store.skipLinkMessage = { ja: '本文に飛ぶ', en: 'Jump to main content' }
  }

  reset()

  watch(
    () => route.path,
    () => {
      reset()
    },
  )

  const skipLinkMessage = computed(() => {
    return store.skipLinkMessage
  })

  const skipLinkTarget = computed(() => {
    return route.hash === store.skipLinkTargetId
      ? route.fullPath
      : `${route.fullPath}${store.skipLinkTargetId}`
  })

  /**
   * ページによって#main以外に飛ばす場合にsetupで呼び出す
   * @param id
   * @param message
   */
  const setSkipLinkTarget = (id: string, message: LangString) => {
    store.skipLinkTargetId = '#' + id
    store.skipLinkMessage = message
  }

  return {
    setSkipLinkTarget,
    skipLinkTarget,
    skipLinkMessage,
  }
}
